import { Component, input } from '@angular/core';

@Component({
  selector: 'app-tab-layout',
  imports: [],
  templateUrl: './tab-layout.component.html',
  styleUrl: './tab-layout.component.scss',
})
export class TabLayoutComponent {
  loading = input<boolean>(false);
  error = input<string | null>(null);
}
